module.exports = __webpack_public_path__ + "img/video-preview-step1.8a5970fb.svg";